'use client';

import { Headline } from "@/frontend/components/ui/headline";
import { PricingTeaserComponent } from "@/payload-types";
import { GridColumn, GridRow } from "@/frontend/components/ui/grid";
import { Button } from "@/frontend/components/ui/button";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import { Checkmark } from "@/frontend/components/ui/icons";
import { useRef } from "react";
import { useInView } from "motion/react";

interface PricingTeaserGroupTypes {
  teaserElements: PricingTeaserComponent['teaserElements'];
};

export const PricingTeaserGroup = ({ teaserElements }: PricingTeaserGroupTypes) => {
  const t = useTranslations('PricingTeaser');
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, {
    once: true,
    amount: 0.4,
  });

  return (
    <div className={clsx('pricing-teaser-group', { 'in-view': isInView })} ref={containerRef}>
      <GridRow>
        { teaserElements?.map((teaserElement, index) => {
          const desc = teaserElement?.descriptionGroup;
          const priceHref = teaserElement?.bottomGroup?.callId ?? t('button.url');

          return (
            <GridColumn key={index} columnSize={{ xs: 12, m: 4 }}>
              <div className={clsx('pricing-teaser-element', desc?.isHighlighted ? 'color-1':'color-0')}>
                <div className="content-top">
                { desc?.heading && <Headline as="h3">{desc?.heading}</Headline> }
                { desc?.isHighlighted && <span className="highlight">{t('highlight')}</span> }
                { desc?.description && <p>{desc?.description}</p> }
                </div>
                <div className="content-list">
                  { teaserElement?.teaserListPoints?.length ? (
                    <ul className="teaser-points">
                      { teaserElement?.teaserListPoints.map((point, index) => {
                        const listPoint = point?.point;
                        return (
                          <li key={index} className="teaser-point">
                            { listPoint && (<>
                              <Checkmark color="var(--font__color)" /> <span>{listPoint}</span>
                            </>)}
                          </li>
                        );
                      })}
                    </ul>
                  ): null}
                </div>
                <div className="content-bottom">
                  { teaserElement.bottomGroup?.price ? <div className="price-container">
                    <span className="price-label">{t('priceLabel')}</span>
                    <span className="price">{teaserElement.bottomGroup.price}</span>
                  </div> : (
                    <div className="price-container">
                      <span className="price-label">{t('noPrice.label')}</span>
                      <span className="price">{t('noPrice.priceString')}</span>
                    </div>
                  )}
                  <Button href={priceHref} colorswoosh={'outline'} buttontext={t('button.label')} target="_blank">
                    <span>{t('button.label')}</span>
                  </Button>
                </div>
              </div>
            </GridColumn>
          )
        })}
      </GridRow>
    </div>
  );
};